import { useModal } from '@ebay/nice-modal-react'
import { useSearch } from '@tanstack/router'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import {
  MessageModal,
  PasswordResetModal,
  WebTitle,
} from '../components/common'
import { Layout } from '../components/layouts'
import { useBoundStore } from '../store/store'
import type { ApiResponse } from '../types/api'
import type { ResetCredentials } from '../types/user'
import { api } from '../utils/api-client'
import Banner from '../components/home-v3/banner'
import Promotions from '../components/home-v3/promotions'
import WhyUs from '../components/home-v3/why-us'
import Transactions from '../components/home-v3/transactions'

const Home = () => {
  const username = useBoundStore(state => state.user.username)
  const messageModal = useModal(MessageModal)
  const passwordResetModal = useModal(PasswordResetModal)
  const { t } = useTranslation('common')
  const { reset_password, ...search } = useSearch({ from: '/' })

  useEffect(() => {
    if (!reset_password) return
    if (username) {
      messageModal.show({
        title: '',
        message: t('already-logged-in'),
      })

      return
    }
    const reqBody = { type: 'verify_reset_password', hash: reset_password }
    api.post('/request.php', reqBody).then(res => {
      const { status, info } = res.data as ApiResponse<
        ResetCredentials | string
      >
      if (status === 1 && typeof info !== 'string') {
        passwordResetModal.show({
          code: info?.code ?? '',
          email: info?.email ?? '',
        })
      } else if (typeof info === 'string') {
        messageModal.show({
          title: t('system'),
          message: info,
        })
      }
    })
  }, [reset_password])

  return (
    <Layout>
      <WebTitle page="home" />
      <Banner />
      <Promotions />
      <WhyUs />
      <Transactions />
    </Layout>
  )
}

export default Home
